import React, { useState, useEffect, useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Image, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion } from '@fortawesome/free-solid-svg-icons'
import { Label, ImgCard, TextArea, BarChat, AutoHeightText } from '../tools'
import { useCustomerJourneyStore } from '../store'
import CardTool from './CardTool'

function SuggestPersona() {
  const {
    user_info,
    emotions,
    opportunities_and_painpoints,
    journeys,
    updateUserInfo,
    updateOAC,
    updateJourneys,
    updateEmotions,
    // setField,
  } = useCustomerJourneyStore((store) => ({
    user_info: store.user_info,
    emotions: store.emotions,
    opportunities_and_painpoints: store.opportunities_and_painpoints,
    journeys: store.journeys,
    updateUserInfo: store.updateUserInfo,
    updateOAC: store.updateOAC,
    updateJourneys: store.updateJourneys,
    updateEmotions: store.updateEmotions,
  }))

  const bars = (emotions.emotions || []).map((item) => item.score)

  const events = useMemo(() => journeys.events || [], [journeys])

  const painpoints = useMemo(
    () =>
      (opportunities_and_painpoints.opportunities_and_painpoints || []).map(
        (item) => ({
          metaKey: 'painpoint',
          content: item.painpoint,
          title: item.painpoint_topic,
          isLoading: item.isLoading,
        })
      ),
    [opportunities_and_painpoints]
  )

  const opportunities = useMemo(
    () =>
      (opportunities_and_painpoints.opportunities_and_painpoints || []).map(
        (item) => ({
          metaKey: 'opportunity',
          content: item.opportunity,
          title: item.opportunity_topic,
          isLoading: item.isLoading,
        })
      ),
    [opportunities_and_painpoints]
  )

  const points = useMemo(
    () => [...painpoints, ...opportunities],
    [painpoints, opportunities]
  )
  // svg size
  const ref = useRef(null)
  const [svgSize, setsvgSize] = useState({
    width: 1000,
    height: 300,
  })

  const getSize = () => {
    if (ref.current) {
      // const style = getComputedStyle(ref.current)
      // const height =
      //   ref.current.clientHeight -
      //   parseFloat(style.paddingTop) -
      //   parseFloat(style.paddingBottom)
      const height = 498
      const width = ref.current.clientWidth
      return { width, height }
    }
    return false
  }

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const size = getSize()
      if (size.width !== svgSize.width || size.height !== svgSize.height)
        setsvgSize(size)
    })
    observer.observe(ref.current)
    return () => ref.current && observer.unobserve(ref.current)
  }, [])

  const [blockLeft, setBlockLeft] = useState(0)
  const [blockOpacity, setBlockOpacity] = useState(0)
  const updatePos = (newPos) => {
    setBlockLeft(newPos)
    setBlockOpacity(1)
  }

  console.log(journeys)

  return (
    <div ref={ref} className="stage-section">
      <div className="info-header">
        <div className="info-header-img">
          <ImgCard setting={{ img: user_info?.image }} />
        </div>
        <div className="info-header-spec">
          {user_info.isLoading ? (
            <Loading setting={{ style: 'one' }} />
          ) : (
            <ul className="spec">
              {user_info.name ? (
                <li>
                  <span className="label-text">姓名</span>
                  <Form.Control
                    name="name"
                    type="text"
                    placeholder="姓名"
                    value={user_info.name}
                    onChange={(e) =>
                      updateUserInfo(e.target.name, e.target.value)
                    }
                  />
                </li>
              ) : (
                <li>
                  <span className="label-text">姓名</span>
                  <Form.Control
                    name="name"
                    type="text"
                    placeholder="姓名"
                    // defaultValue={user_info.name}
                    // onChange={() => {}}
                    disabled
                  />
                </li>
              )}
              {user_info.age ? (
                <li>
                  <span className="label-text">年齡</span>
                  <Form.Control
                    name="age"
                    type="text"
                    placeholder="年齡"
                    value={user_info.age}
                    onChange={(e) =>
                      updateUserInfo(e.target.name, e.target.value)
                    }
                  />
                </li>
              ) : (
                <li>
                  <span className="label-text">年齡</span>
                  <Form.Control
                    name="age"
                    type="text"
                    placeholder="年齡"
                    // defaultValue={user_info.age}
                    // onChange={() => {}}
                    disabled
                  />
                </li>
              )}
              {user_info.male_or_female ? (
                <li>
                  <span className="label-text">性別</span>
                  <Form.Control
                    name="male_or_female"
                    type="text"
                    placeholder="性別"
                    value={user_info.male_or_female}
                    onChange={(e) =>
                      updateUserInfo(e.target.name, e.target.value)
                    }
                  />
                </li>
              ) : (
                <li>
                  <span className="label-text">性別</span>
                  <Form.Control
                    name="male_or_female"
                    type="text"
                    placeholder="性別"
                    // defaultValue={user_info.male_or_female}
                    // onChange={() => {}}
                    disabled
                  />
                </li>
              )}
              {user_info.occupation ? (
                <li>
                  <span className="label-text">職業</span>
                  <AutoHeightText
                    setting={{
                      onChange: (e) => updateUserInfo('occupation', e),
                      value: user_info.occupation,
                      placeholder: '職業',
                      className: 'px-0 pt-0',
                    }}
                  />
                </li>
              ) : (
                <li>
                  <span className="label-text">職業</span>
                  <Form.Control
                    name="job"
                    type="text"
                    placeholder="職業"
                    // defaultValue={user_info.male_or_female}
                    // onChange={() => {}}
                    disabled
                  />
                </li>
              )}
              <li>
                <span className="label-text">任務</span>
                <AutoHeightText
                  setting={{
                    onChange: (e) => updateUserInfo('task', e),
                    value: user_info.task,
                    placeholder: '任務',
                    className: 'px-0 pt-0',
                  }}
                />
              </li>
            </ul>
          )}
        </div>
        <div className="info-header-info flex-1">
          <div className="label-text" style={{ marginLeft: '20px' }}>
            人物基本介紹：
          </div>
          {user_info.isLoading ? (
            <Loading setting={{ style: 'one' }} />
          ) : (
            <TextArea
              setting={{
                value: user_info.user_scenario,
                labelId: 1,
                textEdit: (n, p, value) => {
                  updateUserInfo('user_scenario', value)
                },
              }}
            />
          )}
        </div>
      </div>
      {/* end info-header */}
      <div className="info-body position-relative">
        <div
          className="over-block"
          style={{
            left: `${blockLeft + 2}px`,
            opacity: blockOpacity,
          }}
        >
          &nbsp;
        </div>
        <div className="info-item">
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip
                className="style-dark tooltip-lg"
                style={{
                  zIndex: '9999',
                }}
              >
                <p>
                  顧客旅程通常以「接觸點」顯示具體的互動情境，例如「探索→比較→購買」或「開箱前→中→後」。每個接觸點對應以下資訊：
                </p>
                <ul>
                  <li>
                    使用者情緒：反映使用者在此階段的滿意度（從低到高），幫助您辨識滿意度低的節點進行優化。
                  </li>
                  <li>
                    痛點：說明此階段使用者可能遇到的挑戰，指出導致挫折或不便的原因。
                  </li>
                  <li>機會點：基於使用者需求和痛點，指出潛在的改進方向。</li>
                </ul>
              </Tooltip>
            }
          >
            <div className="tooltip-icon-wrap">
              如何閱讀
              <div className="tooltip-icon">
                <FontAwesomeIcon icon={faQuestion} />
              </div>
            </div>
          </OverlayTrigger>
          <div className="color-title label-title px-0">
            接觸點
            <span
              style={{
                marginLeft: '10px',
                fontWeight: '300',
              }}
            >
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={
                  <Tooltip
                    className="tooltip-lg style-dark"
                    style={{
                      zIndex: '9999',
                    }}
                  >
                    <p>
                      使用者在體驗產品或服務過程中的關鍵階段，涵蓋行動、場景、接觸到的人事物。
                    </p>
                  </Tooltip>
                }
              >
                <Image
                  src="/images/svgicons/tooltip.svg"
                  alt=""
                  className="img-fluid"
                />
              </OverlayTrigger>
            </span>
          </div>
          <div className="row">
            {events.map((item, index) =>
              item.isLoading ? (
                <Loading setting={{ style: 'one' }} />
              ) : (
                <EventItem
                  key={`event${index}`}
                  setting={{
                    item,
                    index,
                    updateJourneys,
                    updatePos,
                    updateOpacity: () => {
                      setBlockOpacity(0)
                    },
                  }}
                />
              )
            )}
          </div>
        </div>
        <div className="info-item">
          <div className="color-title label-title px-0">
            使用者情緒
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip
                  className="style-dark"
                  style={{
                    zIndex: '9999',
                  }}
                >
                  顯示使用者在各接觸點的情緒分數（1-5分），從負面到正面。負面情緒揭示改善空間；正面情緒則突顯體驗強項，適合進一步強化。
                </Tooltip>
              }
            >
              <Image
                src="/images/svgicons/tooltip.svg"
                alt=""
                className="img-fluid"
                style={{
                  marginLeft: '14px',
                }}
              />
            </OverlayTrigger>
          </div>
          <div className="bar-char">
            {emotions.isLoading ? (
              <Loading setting={{ style: 'one' }} />
            ) : (
              <BarChat
                setting={{
                  emotions: bars,
                  edit: true,
                  handleEmotionChange: (value) => {
                    updateEmotions(
                      emotions.emotions.map((e, i) => ({
                        ...e,
                        score: value[i],
                      }))
                    )
                  },
                  ...svgSize,
                }}
              />
            )}
          </div>
        </div>
        <div className="info-item">
          <div className="color-title label-title">痛點</div>
          <div className="point-list">
            {points &&
              points
                .filter(({ metaKey }) => metaKey === 'painpoint')
                .map((item, index) => (
                  <div
                    className="point-card"
                    key={`ponit${index}`}
                    onFocus={() => {}}
                    onMouseOver={(e) => {
                      if (e.target.closest('.point-card')) {
                        updatePos(
                          e.target.closest('.point-card').offsetLeft - 7
                        )
                      }
                    }}
                    onMouseLeave={() => {
                      setBlockOpacity(0)
                    }}
                  >
                    <div
                      style={{
                        marginLeft: '-20px',
                        marginRight: '-20px',
                      }}
                    >
                      <Label
                        setting={{
                          title: item.title,
                          edit: true,
                        }}
                      />
                    </div>
                    {item.isLoading ? (
                      <Loading setting={{}} />
                    ) : (
                      <div
                        className={`has-drag ${
                          item.metaKey === 'painpoint' ? 'weak' : 'chance'
                        }`}
                      >
                        <div className="card-tool">
                          <CardTool
                            setting={{
                              handleRegenerate: () => {
                                // setIsLoading(true)
                              },
                              onlyRegenerate: true,
                            }}
                          />
                        </div>
                        <AutoHeightText
                          setting={{
                            onChange: (e) => {
                              updateOAC(index, item.metaKey, e)
                            },
                            value: item.content,
                            placeholder:
                              item.metaKey === 'painpoint' ? '痛點' : '機會點',
                            className: '',
                          }}
                        />
                      </div>
                    )}
                  </div>
                ))}
          </div>
        </div>
        <div className="info-item">
          <div className="color-title label-title">機會點</div>
          <div className="point-list">
            {points &&
              points
                .filter(({ metaKey }) => metaKey === 'opportunity')
                .map((item, index) => (
                  <div
                    className="point-card"
                    key={`ponit${index}`}
                    onFocus={() => {}}
                    onMouseOver={(e) => {
                      if (e.target.closest('.point-card')) {
                        updatePos(
                          e.target.closest('.point-card').offsetLeft - 7
                        )
                      }
                    }}
                    onMouseLeave={() => {
                      setBlockOpacity(0)
                    }}
                  >
                    <div
                      style={{
                        marginLeft: '-20px',
                        marginRight: '-20px',
                      }}
                    >
                      <Label
                        setting={{
                          title: item.title,
                          edit: true,
                        }}
                      />
                    </div>
                    {item.isLoading ? (
                      <Loading setting={{}} />
                    ) : (
                      <div
                        className={`has-drag ${
                          item.metaKey === 'painpoint' ? 'weak' : 'chance'
                        }`}
                      >
                        <div className="card-tool">
                          <CardTool
                            setting={{
                              handleRegenerate: () => {
                                // setIsLoading(true)
                              },
                              onlyRegenerate: true,
                            }}
                          />
                        </div>
                        <AutoHeightText
                          setting={{
                            onChange: (e) => {
                              updateOAC(index, item.metaKey, e)
                            },
                            value: item.content,
                            placeholder:
                              item.metaKey === 'painpoint' ? '痛點' : '機會點',
                            className: '',
                          }}
                        />
                      </div>
                    )}
                  </div>
                ))}
          </div>
        </div>
      </div>
      {/* end info-body */}
    </div>
  )
}

function EventItem({ setting }) {
  const {
    item,
    index,
    updateJourneys = () => {},
    updatePos = () => {},
    updateOpacity = () => {},
  } = setting

  const array = [...item.action, ...[item.channels_and_stakeholders]]
  let textAreaList = ''
  array.forEach((innerItem) => {
    textAreaList += `<li>${innerItem}</li>`
  })
  textAreaList = `<ul>${textAreaList}</ul>`

  return (
    <div
      className="event-item"
      onFocus={() => {}}
      onMouseOver={(e) => {
        if (e.target.closest('.event-item')) {
          updatePos(e.target.closest('.event-item').offsetLeft)
        }
      }}
      onMouseLeave={() => {
        updateOpacity()
      }}
    >
      <div className="event-item-header">
        <Form.Control
          name="name"
          type="text"
          placeholder="行為標題"
          defaultValue={item.touchpoint}
          onChange={(e) => {
            console.log(e)
          }}
          className="text-center"
        />
      </div>
      <div className="position-relative">
        <div className="event-item-info">
          <TextArea
            setting={{
              value: textAreaList,
              labelId: 1,
              textEdit: (n, p, value) => {
                if (!value) return
                const splited = value.split('\n')
                console.log(
                  splited
                    .slice(1, splited.length - 1)
                    .map((s) => s.replace('<li>', '').replace('</li>', ''))
                )
                updateJourneys(
                  index,
                  'action',
                  splited
                    .slice(1, splited.length - 1)
                    .map((s) => s.replace('<li>', '').replace('</li>', ''))
                )
                // updateJourneys(
                //   index,
                //   'action',
                //   splited
                //     .slice(1, splited.length - 1)
                //     .map((s) => s.replace('<li>', '').replace('</li>', ''))
                // )
                // updateJourneys('user_scenario', value)
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

function Loading({ setting }) {
  const { style } = setting

  if (style === 'one') {
    return (
      <div
        className="loading-wrap"
        style={{
          position: 'static',
        }}
      >
        <div className="loading-bar">loading</div>
      </div>
    )
  }

  return (
    <div className="loading-wrap">
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar mb-4">loading</div>
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar">loading</div>
    </div>
  )
}

EventItem.propTypes = {
  setting: PropTypes.shape().isRequired,
}

Loading.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default SuggestPersona
